import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ROUTES, ROLES } from '../utils/constants';
import MainLayout from '../components/layout/MainLayout';
import AgentDashboard from '../components/admin/agentDashboard/AgentDashboard';

/**
 * Agent Dashboard Page
 * Provides real-time monitoring and control of agents via MQTT
 * @see AGENT_API_CONTRACT.md for the full specification
 */
const AgentDashboardPage = () => {
  const { currentUser, userData, userClaims, isAdmin } = useAuth();
  const navigate = useNavigate();

  // Check if user has admin access
  React.useEffect(() => {
    if (!currentUser) {
      console.log('[AgentDashboardPage] Not authenticated, redirecting to login');
      navigate(ROUTES.LOGIN, { state: { from: window.location.pathname } });
      return;
    }

    // Verify admin permissions
    const userRole = userClaims?.role || userData?.role;
    const hasAdminAccess = userRole === ROLES.ADMIN || userRole === ROLES.TENANT_ADMIN;

    if (!hasAdminAccess && !isAdmin) {
      console.log('[AgentDashboardPage] User does not have admin access');
      navigate(ROUTES.DASHBOARD);
      return;
    }

    console.log('[AgentDashboardPage] User authenticated:', currentUser.email);
  }, [currentUser, userData, userClaims, isAdmin, navigate]);

  return (
    <MainLayout pageTitle="Agent Dashboard">
      <div className="container mx-auto px-4 py-4">
        {/* Header with documentation link */}
        <div className="mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-800">Agent Dashboard</h1>
              {/* <p className="text-gray-500 mt-1">
                Real-time agent monitoring and control via MQTT
              </p> */}
            </div>
            {/* <a
              href="/docs/agent-api-contract.html"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 sm:mt-0 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              API Documentation
            </a> */}
          </div>
        </div>

        {/* User Status Bar */}
        <div className="bg-blue-50 p-4 mb-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-2">User Auth Status</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <p className="text-sm text-gray-600">Email:</p>
              <p className="font-medium">{currentUser?.email || 'Not logged in'}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Role:</p>
              <p className="font-medium">{userClaims?.role || userData?.role || 'None'}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">User ID:</p>
              <p className="font-medium text-xs truncate">{currentUser?.uid || 'N/A'}</p>
            </div>
          </div>
        </div>

        {/* Agent Dashboard Component */}
        <AgentDashboard />
      </div>
    </MainLayout>
  );
};

export default AgentDashboardPage;
